exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".returned-products-modal label {\n  margin: 0;\n}\n.returned-products-modal table td {\n  vertical-align: middle;\n}\n.returned-products-modal input {\n  text-align: right;\n}\n.returned-products-modal .modal-body {\n  padding: 0;\n}\n.returned-products-modal .modal-footer {\n  padding: 0;\n}", ""]);

// exports
